/**
 * @format
 */

import React from 'react';
import { Table, Dropdown, Menu } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setUserId } from 'state/slice/dropDownSlice';
import { setUserProfile } from 'state/slice/buttonSlice';
import { UserData } from '../types/users.types';

interface UsersTableProps {
  users: UserData[];
  loading: boolean;
}

/**
 * Presentational component for users table
 * Displays list of users with actions
 */
const UsersTable: React.FC<UsersTableProps> = ({ users, loading }) => {
  const dispatch = useDispatch();

  const capitalizeName = (name: string): string => {
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const handleMenuClick = (user: UserData) => {
    dispatch(setUserId({ userId: user._id }));
  };

  const columns = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (text: string) => capitalizeName(text),
      sorter: (a: UserData, b: UserData) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (text: string) => capitalizeName(text),
      sorter: (a: UserData, b: UserData) => a.lastName.localeCompare(b.lastName),
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      sorter: (a: UserData, b: UserData) => a.username.localeCompare(b.username),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a: UserData, b: UserData) => a.email.localeCompare(b.email),
    },
    {
      title: 'Agency',
      key: 'officeName',
      sorter: (a: UserData, b: UserData) =>
        (a.office?.officeName || '').localeCompare(b.office?.officeName || ''),
      render: (record: UserData) => record.office?.officeName || 'N/A',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      sorter: (a: UserData, b: UserData) => a.role.localeCompare(b.role),
    },
   
  ];

  return (
    <Table
      dataSource={users}
      columns={columns}
      rowKey={(record) => record._id}
      loading={loading}
      pagination={{ pageSize: 50 }}
    />
  );
};

export default UsersTable;
